import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/icons/arrows/arr-orange-down.svg';
const _hoisted_1 = { class: "mb-4" };
const _hoisted_2 = { class: "d-flex side-box__row align-items-start mt-4" };
const _hoisted_3 = { class: "side-box__content__label mt-sm-5 pt-4 mt-2" };
const _hoisted_4 = { class: "w-100 side-box__content__input side-box__content__input--large border-top ml-3 pt-4 border-top" };
const _hoisted_5 = { class: "d-flex side-box__row align-items-start mt-4" };
const _hoisted_6 = { class: "side-box__content__label" };
const _hoisted_7 = {
    key: 0,
    class: "w-100 side-box__content__input side-box__content__input--large ml-3"
};
const _hoisted_8 = { class: "my-4" };
const _hoisted_9 = { class: "side-box__content__input custom-control__select disabled-with-result mx-auto mt-1" };
const _hoisted_10 = { class: "mt-3" };
import FormInput from "@/components/forms/FormInput.vue";
import FormSelect from "@/components/forms/FormSelect.vue";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { client } from "@/main";
import { useStore } from "vuex";
import FormSelectMultiple from "@/components/forms/FormSelectMultiple.vue";
import ServiceLimits from "@/components/boxes/serviceLimits.vue";
import { useRouter } from "vue-router";
import HwDeviceField from "@/components/devices/partials/HwDeviceField.vue";
import Loader from "@/components/loader.vue";
import { useProjectStore } from "@/store/modules/project";
import UserAttributesField from "@/components/devices/userAttributesField.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UdpDeviceFormFields',
    props: /*@__PURE__*/ _mergeModels({
        readOnly: { type: Boolean }
    }, {
        "modelValue": { required: true },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const model = _useModel(__props, "modelValue");
        const { t } = useI18n();
        const store = useStore();
        const router = useRouter();
        const projectStore = useProjectStore();
        onMounted(() => {
            loadDataFlowList();
            loadTransformationFunctions();
            loadService();
            projectStore.getAllTags(model.value?.device.projectId);
        });
        const isInfoOpen = ref(true);
        const isServiceOpen = ref(false);
        const stateOptions = computed(() => {
            return [
                ...(!model.value.device?.suspended
                    ? [
                        {
                            atomCircleClass: "atom-circle--success",
                            text: t("active"),
                            value: "A",
                            statusText: "active"
                        }
                    ]
                    : [
                        {
                            atomCircleClass: "atom-circle--warning",
                            text: t("overLimit"),
                            value: "A",
                            atomCircleText: "O",
                            statusText: "suspended"
                        }
                    ]),
                {
                    atomCircleClass: "atom-circle--gray",
                    text: t("Standby"),
                    value: "S",
                    statusText: "standby"
                }
            ];
        });
        function updateDeviceField(field, value) {
            model.value = { ...model.value, device: { ...model.value.device, [field]: value } };
        }
        function handleStateSelected(value) {
            if (stateOptions.value.find((op) => op.value === value)?.statusText !== model.value.device.status) {
                model.value = { ...model.value, selectedState: value };
            }
            else {
                model.value = { ...model.value, selectedState: "" };
            }
        }
        const dataFlowList = ref([]);
        async function loadDataFlowList() {
            const { data: result } = await client.path("/device-groups").method("get").create()({
                "projectId[eq]": model.value.device.projectId
            });
            dataFlowList.value = result.data?.filter((group) => group.technology === "UDP");
        }
        function handleDataFlowChanged(value, isMultiple) {
            model.value.device.deviceGroups = isMultiple ? value : [value];
        }
        function handleDataFlowSelectClick({ value, nativeEvent }) {
            if (nativeEvent.ctrlKey) {
                updateDeviceField("deviceGroups", [...model.value.device.deviceGroups, value]);
            }
        }
        const transformationFunctionList = ref([]);
        const isTFLoading = ref(false);
        async function loadTransformationFunctions() {
            isTFLoading.value = true;
            const projectTransformations = await client.path("/transformations").method("get").create()({
                "type[eq]": "IN",
                "sort[eq]": "label",
                "subType[eq]": "UDP",
                "projectId[eq]": router.currentRoute.value.params.projectId
            });
            const publicTransformations = await client.path("/transformations").method("get").create()({
                "type[eq]": "IN",
                "sort[eq]": "label",
                "subType[eq]": "UDP",
                "public[eq]": true
            });
            transformationFunctionList.value = [
                ...(projectTransformations.data.data ?? []),
                ...(publicTransformations.data.data ?? [])
            ];
            isTFLoading.value = false;
        }
        const serviceList = computed(() => {
            const storedServices = store.state.services.services.filter((s) => s.productElementId === "s_iot2293"); // ID for UDP service
            return storedServices.filter((s) => !s.suspended && !s.discontinued);
        });
        async function loadService() {
            if (!model.value.device.serviceId) {
                return;
            }
            const { data } = await client.path("/services/{id}").method("get").create()({
                id: model.value.device.serviceId
            });
            model.value = { ...model.value, selectedService: data.data };
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("a", {
                        class: _normalizeClass([{ opened: isInfoOpen.value }, "atom-form-group__toggler"]),
                        onClick: _cache[0] || (_cache[0] = ($event) => (isInfoOpen.value = !isInfoOpen.value))
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("vaseInformaceOZarizeni")) + " ", 1),
                        _cache[13] || (_cache[13] = _createElementVNode("img", {
                            src: _imports_0,
                            class: "atom-form-group__toggler__arrow"
                        }, null, -1))
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["atom-form-group__content", { opened: isInfoOpen.value }])
                    }, [
                        _createVNode(FormInput, {
                            disabled: _ctx.readOnly,
                            label: _ctx.$t('nazevZarizeni'),
                            placeholder: _ctx.$t('zadejteNazevZarizeni'),
                            value: model.value.device?.name,
                            "side-box": "",
                            onInput: _cache[1] || (_cache[1] = ($event) => (updateDeviceField('name', $event)))
                        }, null, 8, ["disabled", "label", "placeholder", "value"]),
                        _createVNode(FormSelect, {
                            "info-text": 'info_import_spustitZarizeniDoRezimu',
                            "info-tooltip": 'tooltip_import_spustitZarizeniDoRezimu',
                            items: stateOptions.value,
                            label: _ctx.$t('prepnoutDoRezimu'),
                            value: model.value.selectedState
                                ? stateOptions.value.find((op) => op.value === model.value.selectedState)
                                : stateOptions.value.find((op) => op.statusText === model.value.device?.status),
                            "item-text": "text",
                            "item-value": "value",
                            "side-box": "",
                            onChange: _cache[2] || (_cache[2] = (e) => handleStateSelected(e.value))
                        }, null, 8, ["items", "label", "value"]),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("CONNECTED_TO_DATA_FLOW")), 1),
                            _createElementVNode("div", _hoisted_4, [
                                ((model.value.device.deviceGroups?.length ?? 0) < 2)
                                    ? (_openBlock(), _createBlock(FormSelect, {
                                        key: 0,
                                        "custom-action-text": _ctx.$t('CREATE_NEW_DATA_FLOW'),
                                        "has-error": false,
                                        items: dataFlowList.value,
                                        placeholder: _ctx.$t('DEVICE_DATA_FLOW_SELECT_PLACEHOLDER'),
                                        value: model.value.device.deviceGroups?.[0],
                                        class: "mb-4",
                                        "item-subtext": "technology",
                                        "item-text": "deviceGroupName",
                                        "item-value": "deviceGroupId",
                                        label: "",
                                        onChange: _cache[3] || (_cache[3] = ($event) => (handleDataFlowChanged($event, false))),
                                        onMouseup: handleDataFlowSelectClick,
                                        onCustomActionClicked: _cache[4] || (_cache[4] = ($event) => (_unref(router).push({
                                            name: 'dataFlowNew',
                                            params: _unref(router).currentRoute.value.params
                                        })))
                                    }, null, 8, ["custom-action-text", "items", "placeholder", "value"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("TRANSFORMATION_FUNCTION")), 1),
                            (!isTFLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                    _createVNode(FormSelect, {
                                        clearable: "",
                                        class: "mb-4",
                                        "has-error": false,
                                        "item-text": "label",
                                        "item-value": "transformationId",
                                        "item-subtext": "description",
                                        items: transformationFunctionList.value ?? [],
                                        placeholder: _ctx.$t('noTransformFunction'),
                                        label: "",
                                        value: transformationFunctionList.value?.find((tf) => tf.transformationId === model.value.device.transformationId),
                                        onChange: _cache[5] || (_cache[5] = ($event) => (updateDeviceField('transformationId', $event.transformationId))),
                                        onClear: _cache[6] || (_cache[6] = ($event) => (updateDeviceField('transformationId', null)))
                                    }, null, 8, ["items", "placeholder", "value"])
                                ]))
                                : (_openBlock(), _createBlock(Loader, {
                                    key: 1,
                                    class: "w-100 side-box__content__input side-box__content__input--large ml-3"
                                }))
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "side-box__row d-flex align-items-center" }, [
                                _createElementVNode("span", { class: "side-box__content__label" }),
                                _createElementVNode("div", { class: "side-box__content__input ml-3 pb-3 border-top mt-1" })
                            ], -1)),
                            (model.value.device.attributes)
                                ? (_openBlock(), _createBlock(UserAttributesField, {
                                    key: 0,
                                    attributes: model.value.device.attributes,
                                    onChange: _cache[7] || (_cache[7] = ($event) => (updateDeviceField('attributes', $event.reduce((acc, { title, value }) => {
                                        acc[title] = value;
                                        return acc;
                                    }, {}))))
                                }, null, 8, ["attributes"]))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "my-4 side-box__row d-flex align-items-center" }, [
                            _createElementVNode("span", { class: "side-box__content__label" }),
                            _createElementVNode("div", { class: "side-box__content__input ml-3 pb-3 border-top mt-1" })
                        ], -1)),
                        _createVNode(FormSelectMultiple, {
                            items: _unref(projectStore).tagList.map((tag) => {
                                return { text: tag };
                            }),
                            label: _ctx.$t('pridatTagy'),
                            placeholder: _ctx.$t('vyberteTagZeSeznamu'),
                            value: model.value.device.tags?.map((tag) => {
                                return { text: tag };
                            }),
                            class: "mx-auto mt-3",
                            "item-text": "text",
                            "item-value": "text",
                            "side-box": "",
                            onChange: _cache[8] || (_cache[8] = ($event) => (updateDeviceField('tags', $event.map((tag) => tag.text))))
                        }, null, 8, ["items", "label", "placeholder", "value"]),
                        _createVNode(HwDeviceField, {
                            class: "mt-2",
                            "side-box": "",
                            technology: "UDP",
                            value: model.value.device.hwDeviceId,
                            "should-decode-payload-init": model.value?.device.payloadDecode,
                            onChange: _cache[9] || (_cache[9] = ($event) => (updateDeviceField('hwDeviceId', $event))),
                            onPayloadDecodeChanged: _cache[10] || (_cache[10] = ($event) => (updateDeviceField('payloadDecode', $event)))
                        }, null, 8, ["value", "should-decode-payload-init"])
                    ], 2)
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        class: _normalizeClass([{ opened: isServiceOpen.value }, "atom-form-group__toggler"]),
                        onClick: _cache[11] || (_cache[11] = ($event) => (isServiceOpen.value = !isServiceOpen.value))
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("sluzbaALimity")) + " ", 1),
                        _cache[16] || (_cache[16] = _createElementVNode("img", {
                            src: _imports_0,
                            class: "atom-form-group__toggler__arrow"
                        }, null, -1))
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["atom-form-group__content", { opened: isServiceOpen.value }])
                    }, [
                        _createVNode(FormSelect, {
                            items: serviceList.value,
                            label: _ctx.$t('sluzba'),
                            value: model.value.selectedService,
                            "item-subtext": "custServiceId",
                            "item-text": "custServiceName",
                            "item-value": "custServiceId",
                            "side-box": "",
                            onChange: _cache[12] || (_cache[12] = ($event) => (model.value = { ...model.value, selectedService: $event }))
                        }, null, 8, ["items", "label", "value"]),
                        _createElementVNode("div", _hoisted_9, [
                            (model.value.selectedService)
                                ? (_openBlock(), _createBlock(ServiceLimits, {
                                    key: 0,
                                    service: model.value.selectedService
                                }, null, 8, ["service"]))
                                : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("sluzbuMuzeteZmenit")), 1)
                        ])
                    ], 2)
                ])
            ], 64));
        };
    }
});
